import { Component } from '@angular/core';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { TranslatePipe } from '../../../../pipes/translate/translate.pipe';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

@Component({
  selector: 'bizz-grid-cell-enum',
  standalone: true,
  imports: [
    TranslatePipe
  ],
  templateUrl: './grid-cell-enum.component.html',
  styleUrl: './grid-cell-enum.component.scss'
})
export class GridCellEnumComponent extends GridCellBaseComponent<number> {

  public propertyValue: string;

  //If the column doesn't have have display styles we can reduce the padding (for id columns for example)
  public columnHasDisplayStyle = false;

  protected override onDataChanged(): void {
    this.propertyValue = '';
    const idProperty = this.column.field;
    const id = this.data[idProperty];
    if (id != undefined && id >= 0) {
      this.propertyValue = this.column.Enum?.find(_ => _.Value == id)?.Text ?? '';
    }
    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }
}